
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_936mvwBwY8PhMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/[...slug].vue?macro=true";
import { default as autologinzbH2DOsWMuMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/auth/autologin.vue?macro=true";
import { default as callbackQCPLFzvvPTMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/auth/social/[connection]/callback.vue?macro=true";
import { default as _91pageIdentity_93TXWR9vjbmbMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/bonus/[pageIdentity].vue?macro=true";
import { default as bonuses8LBEN9tiK1Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/bonuses.vue?macro=true";
import { default as contactrtVeaudUovMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/contact.vue?macro=true";
import { default as favorites_46clientiyQUH7QgyjMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/favorites.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/builds/platform/customer-frontends/wincasino/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91id_93_46clientM9MgvyXyhpMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/game/[id].client.vue?macro=true";
import { default as _91_46_46_46params_936eEoavQ6H0Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/games/[...params].vue?macro=true";
import { default as indexjJgTy1jq4UMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/games/index.vue?macro=true";
import { default as _91providerIdentity_932tBfnuX7U7Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/games/providers/[providerIdentity].vue?macro=true";
import { default as indexihBphVgPLqMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/games/providers/index.vue?macro=true";
import { default as indexciS1EC1kb3Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/index.vue?macro=true";
import { default as info73V8TyV7rAMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/info.vue?macro=true";
import { default as limitsjR33g8QmzyMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/limits.vue?macro=true";
import { default as personal97kikI6zGZMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/personal.vue?macro=true";
import { default as sessionsNyETqcuTzhMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/sessions.vue?macro=true";
import { default as accountUMHJ8FwnJhMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings/account.vue?macro=true";
import { default as notificationsf8cKLvG2ipMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings/notifications.vue?macro=true";
import { default as settingsaLECAH6g7AMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings.vue?macro=true";
import { default as profileGirHxMcV8lMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile.vue?macro=true";
import { default as _91pageIdentity_93YVR1WsxPnLMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/questions/[pageIdentity].vue?macro=true";
import { default as questionsY89bGW8q6VMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/questions.vue?macro=true";
import { default as recently_45played_46clientQALPRYqZkVMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/recently-played.client.vue?macro=true";
import { default as redirect_46clienttE8a4sQD9lMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/redirect.client.vue?macro=true";
import { default as referralgtEGKjvd1sMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/referral.vue?macro=true";
import { default as _91_46_46_46slug_93coDqc8F1jkMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/sport/[...slug].vue?macro=true";
import { default as _91pageIdentity_93Mv2FcmJwmsMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/static/[pageIdentity].vue?macro=true";
import { default as supportYVJiG1Sd5kMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/support.vue?macro=true";
import { default as historyO4EpgYB8GqMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet/history.vue?macro=true";
import { default as indexR2eFRn4iHHMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet/index.vue?macro=true";
import { default as walletrZl01XisEeMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet.vue?macro=true";
import { default as welcome_45packageLrLJaTgYghMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/welcome-package.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/[...slug].vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/auth/autologin.vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/auth/social/[connection]/callback.vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/bonuses.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/favorites.client.vue"))
  },
  {
    name: "game-id",
    path: "/game/:id()",
    component: () => createClientPage(() => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/game/[id].client.vue"))
  },
  {
    name: "games-params",
    path: "/games/:params(.*)*",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/games/[...params].vue")
  },
  {
    name: "games",
    path: "/games",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/games/index.vue")
  },
  {
    name: "games-providers-providerIdentity",
    path: "/games/providers/:providerIdentity()",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/games/providers/[providerIdentity].vue")
  },
  {
    name: "games-providers",
    path: "/games/providers",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/games/providers/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile.vue"),
    children: [
  {
    name: "profile-info",
    path: "info",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/limits.vue")
  },
  {
    name: "profile-personal",
    path: "personal",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/personal.vue")
  },
  {
    name: "profile-sessions",
    path: "sessions",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/sessions.vue")
  },
  {
    name: "profile-settings",
    path: "settings",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings.vue"),
    children: [
  {
    name: "profile-settings-account",
    path: "account",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings/account.vue")
  },
  {
    name: "profile-settings-notifications",
    path: "notifications",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings/notifications.vue")
  }
]
  }
]
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionsY89bGW8q6VMeta || {},
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/recently-played.client.vue"))
  },
  {
    name: "redirect",
    path: "/redirect",
    meta: redirect_46clienttE8a4sQD9lMeta || {},
    component: () => createClientPage(() => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/redirect.client.vue"))
  },
  {
    name: "referral",
    path: "/referral",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/referral.vue")
  },
  {
    name: "sport-slug",
    path: "/sport/:slug(.*)*",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/sport/[...slug].vue")
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/static/[pageIdentity].vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/support.vue")
  },
  {
    name: walletrZl01XisEeMeta?.name,
    path: "/wallet",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet.vue"),
    children: [
  {
    name: "wallet-history",
    path: "history",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet/history.vue")
  },
  {
    name: "wallet",
    path: "",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet/index.vue")
  }
]
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/welcome-package.vue")
  }
]